// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserMessage_wrapper__YepwU","bubble":"UserMessage_bubble__2MFoD","text":"UserMessage_text__1JWw7","time":"UserMessage_time__1ZaPt"};